import React from "react";
import { SvgIcon } from "@material-ui/core";

const BotonDePagoIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <path d="M32.127 34.165a.412.412 0 01-.411-.412v-6.7a.411.411 0 01.823 0v6.7a.412.412 0 01-.412.412z" />
    <path d="M35.479 30.813h-6.7a.411.411 0 110-.823h6.7a.411.411 0 010 .823zM27.659 20.759a.412.412 0 01-.412-.411v-3.91a4.615 4.615 0 10-9.23 0v3.91a.412.412 0 01-.824 0v-3.91a5.439 5.439 0 0110.878 0v3.91a.412.412 0 01-.412.411z" />
    <path d="M24.708 30.429a7.356 7.356 0 016.94-7.34c.013-.038.025-.063.033-.064a.414.414 0 00.365-.455l-.626-5.62a.412.412 0 00-.41-.366H14.252a.412.412 0 00-.409.366l-1.821 16.388a3.756 3.756 0 003.738 4.178h13.428a.408.408 0 00.336-.186 7.359 7.359 0 01-4.816-6.901z" />
    <path d="M0 0h48v48H0z" fill="none" />
  </SvgIcon>
);
BotonDePagoIcon.displayName = "BotonDePagoIcon";
BotonDePagoIcon.muiName = "BotonDePagoIcon";

export default BotonDePagoIcon;
